<template>
  <div v-if="id" class="dispatch-board">
    <activities :current-job-id="id" :readonly="true"></activities>
  </div>
</template>

<script type="text/babel">
import Activities from "./partials/Activities.vue";

export default {
  components: {
    Activities,
  },

  data() {
    return {
      tabIndex: 0,
    };
  },

  computed: {
    id() {
      if (this.$route.params.id) {
        return Number(this.$route.params.id);
      }

      return false;
    },
  },
};
</script>
